import React, { useContext } from 'react';
import Icon from '@xo-union/tk-component-icons';
import styles from './guidanceItemCard.scss';
import { PageItemIcon } from '../PageItemsRail/PageItemIcon';
import GuidancePreviewImage from './GuidancePreviewImage';
import { newItemsRoute } from '../../helpers/routes';
import { Link } from 'react-router-dom';
import { kebabCase } from 'lodash';
import pluralize from 'pluralize';
import { TrackingContext } from '../../TrackingContext';

interface Props {
  pageId: number;
  pageItemTypes?: string[];
}

const CustomItemCard: React.FC<Props> = ({ pageItemTypes, pageId }) => {
  const { track } = useContext(TrackingContext);
  if (!pageItemTypes || pageItemTypes.length < 1) {
    return null;
  }

  const firstThreeTypes = pageItemTypes.splice(0, 3);

  const onClick = (guidanceType: string) => {
    track('Item Action Initiated', { source: 'guidance', type: guidanceType, page: pageId });
  };

  return (
    <div className={styles.guidanceItem}>
      <GuidancePreviewImage>
        <div className={styles.customItemIcons}>
          {firstThreeTypes?.map(guidanceType => {
            return (
              <div className={styles.icon} key={guidanceType}>
                {/* photoItemfield works but requires some refactoring to not use RightRailContext */}
                {guidanceType === 'PhotoItem' ? (
                  <Link to={newItemsRoute(pageId)}>
                    <PageItemIcon key="more" icon="PhotoItem" />
                  </Link>
                ) : (
                  <Link
                    to={`gs/dashboard/pages/${pageId}/${pluralize(kebabCase(guidanceType))}`}
                    onClick={() => onClick(guidanceType)}
                  >
                    <PageItemIcon icon={guidanceType} />
                  </Link>
                )}
              </div>
            );
          })}
          {pageItemTypes.length > 3 && (
            <div className={styles.icon}>
              <Link to={newItemsRoute(pageId)}>
                <PageItemIcon key="more" icon="MoreItem" />
              </Link>
            </div>
          )}
        </div>
      </GuidancePreviewImage>
      <div className={styles.guidanceLink}>
        <Link to={newItemsRoute(pageId)}>
          Add Anything Else
          <Icon name="forward" />
        </Link>
      </div>
    </div>
  );
};
export default CustomItemCard;
